module.exports = __webpack_public_path__ + "img/img45.90308141.svg";